const PROCTORING_IMAGE_TYPE = {
    SCREEN: 'screen',
    WEBCAM: 'webcam',
}

export default PROCTORING_IMAGE_TYPE
